export default __webpack_public_path__ + "static/media/logo.d136cea3.png";